const expectedCacheNames = ['mySYNCH-v1-36a'];

const cacheList = [
  `./index.js`,
  `./config.js`,
  `./config-local.js`,
  `./config-stage.js`,
  `./config-test.js`,
  `./sw.js`,
  `./bundle.js`,
  `./bundle-min.js`,
  `./templates.js`,
  `/config`,
  `./app/index.js`,
  `./app/log.js`,
  `./app/modules.js`,
  `./notifications/notifications.controller.js`,
  `../css/bootstrap.css`,
  `../css/font-awesome.css`,
  `../css/site.css`,
  `../css/mysynch.css`,
  `../lib/modernizr-2.8.3.js`,
  `../lib/angular-1.5.9/angular.js`,
  `../lib/jquery-ui-1.11.4.js`,
  `../lib/jquery-2.1.4.js`,
  `../lib/jquery.validate.js`,
  `../lib/jquery.validate-vsdoc.js`,
  `../lib/bootstrap.js`,
  `../lib/respond.js`,
  `../lib/globalize.js`,
  `../lib/angular-1.5.9/angular-animate.js`,
  `../lib/angular-1.5.9/angular-sanitize.js`,
  `../lib/angular-ui-router.js`,
  `../lib/angular-1.5.9/angular-cookies.js`,
  `../lib/q.js`,
  `../lib/dx.chartjs.debug.js`,
  `../lib/adal-angular.js`,
  `../lib/adal.js`,
  `../lib/angular-ui/ui-bootstrap-tpls-2.5.0.js`,
  `../lib/async/lib/async.js`,
  `../lib/angular-trix.js`,
  `../lib/powerbi.min.js`,
  `../img/logo-mysynch-dark-c5c808fa.png`,
  `../img/parnell-icon.png`,
  `../img/offline.png`,
  `../img/online.png`,
  `../img/content-background.gif`,
  `../img/nav-icons/dashboard-icon.png`,
  `../img/nav-icons/education-icon.png`,
  `../img/nav-icons/barn-icon.png`,
  `../img/nav-icons/benchmarking-icon.png`,
  `../img/material-icons/google-material-icon-file_download_black_48dp.svg`,
  `../img/material-icons/google-material-icon-vaccines_white_48dp.svg`,
  `../img/material-icons/google-material-icon-info.svg`,
  `../fonts/fontawesome-webfont.woff2?v=4.3.0`,
  `../js/application-insights.js`,
  `./error/error.controller.js`,
  `../partials/error/error.view.html`,
  `./services/audit.service.js`,
  `./services/f360.filter.js`
];

self.addEventListener('install', e => {
  console.log("installing service worker with cache: "+expectedCacheNames[0]);
    e.waitUntil(
      caches.open(expectedCacheNames[0]).then(cache => {
        return cache.addAll(cacheList)
            .then(() => self.skipWaiting());
      })
    );
});
self.addEventListener('activate', event => {
//event.waitUntil(self.clients.claim());
// delete any caches that aren't in expectedCaches
console.log("activating service worker with cache: "+expectedCacheNames[0]);
  event.waitUntil(
    caches.keys().then(keys => Promise.all(
      keys.map(key => {
        if (!expectedCacheNames.includes(key)) {
          return caches.delete(key);
        }
      })
    )).then(() => {
      console.log('V2 now ready to handle fetches!');
      return self.clients.matchAll().then(function (clients) {
        clients.forEach(function (client) {
        console.log("The Client: ");
        console.log(client);
       var test = "";
          var message = {
            type: 'refresh_notification'
          };
    
          client.postMessage(JSON.stringify(message));
        });
        
      });
    })
  );
});


self.addEventListener('fetch', event => {
event.respondWith(
    caches.open(expectedCacheNames[0])
    .then(cache => cache.match(event.request, {ignoreSearch: true}))
    .then(response => {

      var serverFirstCacheSecondList = [
        "bundle.js",
        "bundle-min.js",
        "templates.js",
        ".css",
        "index.html"
     ]
      var isServerFirst = false;
      if(response){
       for(var i = 0; i < serverFirstCacheSecondList.length;i++){
           if(response.url.indexOf(serverFirstCacheSecondList[i]) > -1){
             isServerFirst = true;
             break;
           }
      };
    }

      if(response && isServerFirst === true){
       return fetch(event.request,{cache: 'reload'})
        .then(function(responseFetch){
          caches.open(expectedCacheNames[0])
              .then(function(cache) {
                cache.put(event.request, responseFetch.clone()); 
              });
          return responseFetch.clone();
        })
        .catch(function(error){
           return response;
        })

      }else{
     
        if(response){
             return response;
           }
           
                 return fetch(event.request,{cache: 'reload'})
                  // .then(function(responseFetch){
                  //   return responseFetch.clone();
                  // })
                  .catch(function(error){
                    console.log("SW- failed to fetch request in  Fetch EventLister");
                    return response;
                  });
           
           
         //return response || fetch(event.request,{cache: 'no-store'});
      }
      
    
    })
);
});